<template>
  <div class="btn" :class="cls" :data-color="color" @mousedown="doRipple($event)">
    <span class="icon-l" v-if="iconL">{{iconL}}</span>
	  <div class="inner">
      <slot></slot>
    </div>
    <span class="icon-r" v-if="iconR">{{iconR}}</span>
    <div class="ripple" :style="rippleStyle()"></div>
  </div>
</template>


<script>
//import jQuery from 'jQuery'
export default {
  props: {
    color: String,
    disabled: { type:Boolean, default:false },
    full: { type:Boolean, default:false },
    block: { type:Boolean, default:false },
    large: { type:Boolean, default:false },
    small: { type:Boolean, default:false },
    iconR: { default:false },
    iconL: { default:false },
  },
  data(){
    return {
      ripple: {
          top: 0,
          left: 0,
          size: 150,
          active: false,
      }
    }
  },
  computed:{
    cls(){
      var output = ''
      if( this.disabled == true ) output += 'disabled '
      if( this.large == true ) output += 'btn-large '
      if( this.small == true ) output += 'btn-small '
      if( this.full == true ) output += 'block '
      if( this.block == true ) output += 'block '
      if( this.color ) output += 'color-'+this._props.color
      if( this.ripple.active ) output += ' rippling '
      if( this.iconL || this.iconR ) output += ' has-icon '
      if( this.iconL ) output += ' has-icon-l '
      if( this.iconR ) output += ' has-icon-r '
      return output
    },
  },
  methods: {

    doRipple(e){
      if( this.ripple.active ) return
      this.ripple.top = e.offsetY
      this.ripple.left = e.offsetX
      this.ripple.active = true
      var _this = this
      setTimeout(function(){
        _this.ripple.active = false
      }, 400)
    },

    rippleStyle() {
        return {
            height: this.ripple.size + 'px',
            width: this.ripple.size + 'px',
            top: this.ripple.top + 'px',
            left: this.ripple.left + 'px',
            marginLeft: - (this.ripple.size/2) + 'px',
            marginTop: - (this.ripple.size/2) + 'px',
        };
    },

  },
}
</script>



// WEBPACK FOOTER //
// Btn.vue?00c9e1da